import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import AppRuntimeEnv from "@/types/AppRuntimeEnv";
import { AuthData } from "@/types/LocalConfig";

import logger from "@/utils/logger";
import IconFont, { IconHomeApp } from "@/components/icon";
import { EventEmitter } from "events";
import BrowserView from "@/components/BrowserView";

import { useTranslation } from "react-i18next";
import { FocusSDK, getSecretKey, getWebEnvObj, isBjme, isFocusEnv, isMac } from "@/utils";
import Bus from "@/utils/bus";
import { message, Modal } from "antd";
import { connect } from "dvajs";
import { analysisLog } from "@/utils/logAnalytics";
import { getAppVersion, getVersionInfo } from "@/utils/getVersion";

import { getCityCode, HomeContext, PerformanceContext } from "./utils";

import "./index.less";
import HomeIndex from "./components/HomeIndex";
import { AVSDK } from "@/baseComponents/Meeting/common";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import { getNetCheckUrl } from "@/config/config";
import { WebviewKernel } from "@/services/AppStore";
import GError from "@/utils/GError";
import { isLogin } from "@/utils/user";
import { APP_NAME } from "@/config/name";
import { GATEWAY_VERSION } from "@/server/constants";
export const homeKey = "startup-page";
export const homePartitionKey = "builtin-home-apps";
const log = logger.getLogger("HomeApp");

export const notifyer = new EventEmitter();
const getAppItemUrl = (items: any[]) => {
  let url = null;
  const key = isMac() ? 5 : 4;

  const selectItem = items.filter((item) => {
    return item.hostAppClient === key;
  });
  console.log("getAppItemUrl", selectItem);
  if (selectItem.length > 0) {
    url = selectItem[0].homeUrl;
  }
  console.log(url, "getAppItemUrl", items);
  return url;
};
export const genThirdAppUrl = (
  applicationKey: string,
  appId: string,
  accessToken: string,
  appRuntime: AppRuntimeEnv,
  options?: {
    redirectUrl?: string;
  }
  // eslint-disable-next-line max-params
) => {
  const s = new URL(`${appRuntime.meMainEntry}/passport/api/desktop/app/redirect/`);
  s.searchParams.append("applicationKey", applicationKey);
  s.searchParams.append("appKey", appId);
  s.searchParams.append("client", (!isFocusEnv() && "web") || appRuntime.registryConfig.client);
  s.searchParams.append("accessToken", accessToken);
  s.searchParams.append("teamId", appRuntime.selectedTeamId);
  if (options?.redirectUrl) {
    s.searchParams.append("redirectUrl", encodeURIComponent(options.redirectUrl));
  }
  return s.toString();
};

function StartupBody({
  visible,
  loading,
  selectedId,
  isActive,
  appRuntimeEnv,
  authInfo,
  isOnline
}: {
  visible?: boolean;
  loading: boolean;
  selectedId: string;
  isActive: boolean;
  appRuntimeEnv: AppRuntimeEnv;
  authInfo: AuthData;
  isOnline: boolean;
}) {
  const isPrivateNet = FocusSDK.isPrivateNet();

  return (
    <HomeContext.Provider
      value={{
        isOnline,
        isActive,
        notifyer,
        appRuntimeEnv,
        authInfo,
        selectedId
      }}
    >
      <div
        style={{
          position: "absolute",
          width: "100%",
          display: selectedId === homeKey ? "block" : "none",
          height: "100%"
        }}
      >
        <HomeIndex />
      </div>
    </HomeContext.Provider>
  );
}

function HomeApp(props: any) {
  const { authInfo: config, appRuntimeEnv, focusSDK, onGlobalError } = React.useContext<
    GlobalContextConfig
  >(GlobalContext);
  const [selectedId, setSelectedId] = React.useState(homeKey);
  const { setHomeAppData } = props;
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("common");
  const [isActive, setIsActive] = useState(true);
  const [isOnline, setIsOnline] = useState(false);
  const [appClickTime, setAppClickTime] = useState(0);
  // 布局
  const defaultPage = {
    id: homeKey,
    icon: IconHomeApp,
    title: `${APP_NAME} | ${appRuntimeEnv.getI18N("layout.nav.homePage")}`,
    body: (
      <StartupBody
        visible
        loading={loading}
        selectedId={selectedId}
        appRuntimeEnv={appRuntimeEnv}
        authInfo={config}
        isActive={isActive}
        isOnline={isOnline}
      />
    )
  };

  // 打开工具
  const openHomeApp = React.useCallback(
    // eslint-disable-next-line complexity
    async (curitem, info) => {
      console.log("openHomeApp", curitem, info);
      if (curitem.urlType !== 1 && curitem.urlType !== 2) return;

      if (curitem.urlType === 1) {
        const src = curitem.pcUrl;
        try {
          if (!isFocusEnv()) {
            focusSDK.openUrl(src);
            return;
          }
          notifyer.emit("clientMessage", {
            event: "openNewWindow",
            payload: {
              urls: [src],
              isThirdApp: false
            }
          });
        } catch (e) {
          console.log(e, "e");
        }
        return;
      }
      if (curitem.urlType === 2) {
        if (!isLogin(appRuntimeEnv)) {
          focusSDK.emit("showLogin", {
            content: curitem,
            type: "openHomeApp"
          });
          return;
        }
        console.log("打开应用", curitem, info);
        setAppClickTime(new Date().getTime());
        //   let item = getApplication(
        //     theThirdAppListAll.current,
        //     (item) => item.applicationKey === curitem.applicationKey
        //   );
        //   FocusSDK.printLog("openHomeApp", curitem);

        // 必须在处理最近使用下面，因为，最近使用需要根据item是否为null判定是否加入最近使用
        const item = curitem;

        let redirectUrl: string | null = "";
        try {
          redirectUrl = getAppItemUrl(item.applicationBaseInfoList);
        } catch (e) {
          console.log("this is redirect", e);
        }
        const src = genThirdAppUrl(
          item.applicationKey,
          config.ddAppId,
          config.accessToken,
          appRuntimeEnv,
          {
            redirectUrl: ""
          }
        );
        console.log(src, "src111", redirectUrl);
        try {
          if (!isFocusEnv()) {
            focusSDK.openUrl(src);
            return;
          }
          setHomeAppData({ appId: item.applicationId, appData: item });
          log.debug("主窗口打开 ===>>>", src, item);
          notifyer.emit("clientMessage", {
            event: "openNewWindow",
            payload: {
              urls: [src],
              name: item.applicationName,
              phone: item.csTelephone || "",
              company: item.omCompany || "",
              appKey: item.applicationKey,
              trustedDomains: item.trustedDomains || "",
              version: item.version,
              isThirdApp: true,
              homeUrl: FocusSDK.isPrivateNet() ? item.egovHomeUrl || item.homeUrl : item.homeUrl
            }
          });
        } catch (error) {
          console.log("错误", error);
          onGlobalError(error);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [appRuntimeEnv, config, focusSDK, onGlobalError, t, history]
  );
  useEffect(() => {
    Bus.on("openHomeApp", openHomeApp);
    return () => {
      Bus.off("openHomeApp", openHomeApp);
    };
  }, [openHomeApp]);
  const openHomeH5 = useCallback(
    (item) => {
      console.log("openHomeH5", item, config);
      const authInfo = config;
      try {
        if (!item.pcUrl) return;
        if (!isLogin(appRuntimeEnv)) {
          FocusSDK.emit("showLogin", {
            type: "openHomeH5",
            content: item
          });
          return;
        }
        const urlObj = new URL(`${appRuntimeEnv?.meMainEntry}${item.pcUrl}`);
        urlObj.searchParams.append("xGwAppId", appRuntimeEnv.gateway.appId);
        urlObj.searchParams.append("xAppVersion", getAppVersion(FocusSDK));

        const secretKey = getSecretKey();
        console.log(secretKey, "secretKey");
        urlObj.searchParams.append(`xSignKey`, secretKey);
        urlObj.searchParams.append(
          "xClient",
          (!isFocusEnv() && "web") || appRuntimeEnv.registryConfig.client
        );
        urlObj.searchParams.append("xDid", appRuntimeEnv.registryConfig.machineId);
        urlObj.searchParams.append("xGwVersion", GATEWAY_VERSION as any);
        urlObj.searchParams.append("xStage", appRuntimeEnv.gateway.stage);
        urlObj.searchParams.append("xTeamId", appRuntimeEnv.selectedTeamId);
        urlObj.searchParams.append("xToken", authInfo.accessToken);
        urlObj.searchParams.append(`xAppId`, `${authInfo.ddAppId}`);
        urlObj.searchParams.append(`cityCode`, getCityCode());
        const src = urlObj.toString();
        console.log(src, "openInnerH5:urlObjurl");
        if(!isFocusEnv()){
          return window.open(src);
        }
        notifyer.emit("clientMessage", {
          event: "openNewWindow",
          payload: {
            urls: [src],
            isThirdApp: false
          }
        });
      } catch (err) {
        console.log(err, "err222");
      }
    },
    [appRuntimeEnv, config]
  );
  useEffect(() => {
    Bus.on("openHomeH5", openHomeH5);
    return () => {
      Bus.off("openHomeH5", openHomeH5);
    };
  }, [openHomeH5]);
  useEffect(() => {}, []);
  const onNavItemClick = useCallback((path: string) => {
    if (path === "/homePage") {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, []);

  useEffect(() => {
    const fatherDiv: any = (document.getElementById("home-apps") as any)?.parentNode;
    fatherDiv && (fatherDiv.style.height = "100%");
  }, []);

  //   const getOpenLinks = (links: any) => {
  //     setOpenLinkList(links);
  //   };
  //   useEffect(() => {
  //     notifyer.on("getOpenLinks", getOpenLinks);
  //   });
  if (!appRuntimeEnv) {
    return null;
  }
  return (
    <HomeContext.Provider
      value={{
        isOnline,
        isActive,
        notifyer,
        appRuntimeEnv,
        authInfo: config,
        selectedId: selectedId
        //   onChangeFavoriteSortType
      }}
    >
      <div
        id="home-apps"
        style={{
          flexDirection: "column",
          height: "100%"
        }}
      >
        <BrowserView
          configData={{
            urls: [],
            partition: homePartitionKey,
            allowedHosts: []
          }}
          notifier={notifyer}
          defaultPage={defaultPage}
          onTabChange={(selectedId1: any) => {
            console.log(selectedId1, "selectedId1");
            setSelectedId(selectedId1);
          }}
          style={{ display: "block", height: "calc(100% - 48px)", position: "relative" }}
          isApplications={false}
          // thirdAppListAll={thirdAppListAll}
        />
      </div>
    </HomeContext.Provider>
  );
}

function mapStateToProps() {
  return {};
}
function mapDispatchToProps(dispatch: any) {
  return {
    setHomeAppData(data: any) {
      dispatch({ type: "homeApp/setHomeAppData", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeApp);
